// InovaMix Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ---- MOBILE MENU ----
  const toggle = document.getElementById('mobileMenuToggle');
  const mobileNav = document.getElementById('mobileNav');
  const overlay = document.getElementById('mobileOverlay');
  const closeBtn = document.getElementById('mobileNavClose');

  function openMenu() {
    mobileNav && mobileNav.classList.add('open');
    overlay && overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileNav && mobileNav.classList.remove('open');
    overlay && overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  toggle && toggle.addEventListener('click', openMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay && overlay.addEventListener('click', closeMenu);

  // ---- FADE IN ANIMATIONS ----
  const fadeEls = document.querySelectorAll('.fade-in');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(el => io.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  // ---- COUNTDOWN TIMER ----
  function startCountdown(targetId, hours, minutes, seconds) {
    const el = document.getElementById(targetId);
    if (!el) return;
    let total = hours * 3600 + minutes * 60 + seconds;
    function tick() {
      if (total <= 0) return;
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      const hEl = el.querySelector('[data-h]');
      const mEl = el.querySelector('[data-m]');
      const sEl = el.querySelector('[data-s]');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
      total--;
      setTimeout(tick, 1000);
    }
    tick();
  }
  startCountdown('promoCountdown', 5, 47, 23);

  // ---- PURCHASE NOTIFICATIONS (Social Proof) ----
  const notifData = [
    { name: 'Maria S.', city: 'São Paulo', product: 'Kit Skincare Premium' },
    { name: 'João R.', city: 'Rio de Janeiro', product: 'Fone Bluetooth Pro' },
    { name: 'Ana C.', city: 'Belo Horizonte', product: 'Massageador Elétrico' },
    { name: 'Lucas M.', city: 'Curitiba', product: 'Luminária LED Smart' },
    { name: 'Fernanda T.', city: 'Fortaleza', product: 'Relógio Smartwatch' },
    { name: 'Paulo H.', city: 'Salvador', product: 'Camiseta Fitness' },
    { name: 'Camila B.', city: 'Brasília', product: 'Perfume Importado' },
    { name: 'Rafael G.', city: 'Manaus', product: 'Mini Ventilador USB' },
  ];
  const notif = document.getElementById('purchaseNotification');
  if (notif) {
    let idx = 0;
    function showNotif() {
      const d = notifData[idx % notifData.length];
      document.getElementById('notifName').textContent = d.name;
      document.getElementById('notifCity').textContent = d.city;
      document.getElementById('notifProduct').textContent = d.product;
      notif.classList.add('show');
      setTimeout(() => notif.classList.remove('show'), 4000);
      idx++;
      setTimeout(showNotif, 8000 + Math.random() * 4000);
    }
    setTimeout(showNotif, 3000);
  }

  // ---- THUMBNAIL SWITCHER ----
  const thumbs = document.querySelectorAll('.thumb');
  const mainImg = document.querySelector('.main-image img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) {
        const src = this.querySelector('img')?.src;
        if (src) { mainImg.src = src; }
      }
    });
  });

  // ---- STICKY HEADER SCROLL ----
  const header = document.querySelector('.site-header');
  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    const curr = window.scrollY;
    if (header) {
      if (curr > 80 && curr > lastScroll) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
    }
    lastScroll = curr;
  });
  if (header) header.style.transition = 'transform 0.3s ease';

});
